import React from 'react';

import { AppLayout } from '../../components/layout/AppLayout/AppLayout';

interface INotFoundProps { }

export const NotFound: React.FunctionComponent<INotFoundProps> = () => (
  <AppLayout className="flex-row align-items-center justify-content-center">
    <h4>Page not found</h4>
  </AppLayout>
);
